// Used in resource-container.component.html

// Angular
import { Component, OnInit, Input } from "@angular/core";

@Component({
    selector: "assets-by-page-button",
    templateUrl: "./assets-by-page-button.component.html",
    styleUrls: ["./assets-by-page-button.component.scss"],
    standalone: false
})
export class AssetsByPageButtonComponent implements OnInit {
    /** Whether the assignables drawer is currently open. Drives the chevron direction. */
    @Input() opened = false;

    constructor() {}

    ngOnInit() {}
}
